<script setup lang="ts"></script>

<template>
  <icon name="lucide:settings-2" />
</template>

<style scoped></style>
